import type { TeamRole } from './employee-team.model';

export interface PersonTeamAssignment {
  id: string;
  personId: string;
  teamId: string;
  role: TeamRole;
  startDate?: string | null;
  endDate?: string | null;
  teamName: string;
}
